// src/config/index.ts
export const config = {
    api: {
      baseUrl: process.env.REACT_APP_API_BASE_URL,
      authUrl: process.env.REACT_APP_AUTH_URL
    },
    sdk: {
      loanCalculator: process.env.REACT_APP_LOAN_CALCULATOR_URL,
      payments: {
        url: process.env.REACT_APP_PAYMENTS_SDK_URL,
        accessKey: process.env.REACT_APP_PAYMENTS_ACCESS_KEY,
      },
      openbanking: {
        url: process.env.REACT_APP_OPENBANKING_SDK_URL,
        accessKey: process.env.REACT_APP_OPENBANKING_ACCESS_KEY,
      },
      paymentsAccessKey: process.env.REACT_APP_PAYMENTS_ACCESS_KEY,
    },
    business: {
      name: "Prestix",
      domain: process.env.REACT_APP_DOMAIN,
      applicationToken: process.env.REACT_APP_APPLICATION_TOKEN,
      phone: process.env.REACT_APP_WHATSAPP_PHONE,
      termsUrl: process.env.REACT_APP_TERMS_URL,
      privacyUrl: process.env.REACT_APP_PRIVACY_POLICY_URL
    },
    environment: {
      biometriaEnabled: process.env.REACT_APP_BIOMETRIA_ENABLED !== 'false',
      skipCbuVerification: process.env.REACT_APP_SKIP_CBU_VERIFICATION !== 'false',
    },
    maintenance: {
      enabled: process.env.REACT_APP_MAINTENANCE_MODE === 'true',
      message: process.env.REACT_APP_MAINTENANCE_MESSAGE || 'Estamos realizando mejoras. Volveremos en breve.',
    },
  };